import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { GlobalHelper } from '../Common/global.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})

export class SuperadminService {

  constructor(private globalHelper: GlobalHelper, private httpclient: HttpClient) { }

  // CHANNEL PARTNER MASTER------------------------------------------------------


  SavePartner(strdata,logo): Observable<any> {
    let formData = new FormData();
    formData.append("partnerDetails", strdata);
    formData.append("partnerLogoFile", logo);
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'SuperAdmin/SavePartner', formData);
  }
  PartnerMarkActive(strdata: any): Observable<any> {  
    let Parameter = 'objModel=' + strdata;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'SuperAdmin/PartnerMarkActive?'
     + encodeURI(Parameter),
      { headers: reqHeader });
  }

  BindPartner(): Observable<any> {
   var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
     return this.httpclient.post<any>(this.globalHelper.ApiUrl +
      'SuperAdmin/BindPartner', { headers: reqHeader });
  }


   // ACCOUNT MASTER------------------------------------------------------


   SaveSchool(strdata,logo): Observable<any> {
    let formData = new FormData();
    formData.append("schoolDetails", strdata);
    formData.append("schoolLogoFile", logo);
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'SuperAdmin/SaveSchoolMST', formData);
  }
  SchoolMarkActive(strdata: any): Observable<any> {  
    let Parameter = 'objschoolModel=' + strdata;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'SuperAdmin/SaveSchoolMarkActive?'
     + encodeURI(Parameter),
      { headers: reqHeader });
  }
  
  GetAllSchool(strdata: any): Observable<any> {  
    let Parameter = 'objschoolModel=' + strdata;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'SuperAdmin/GetAllSchool?'
     + encodeURI(Parameter),
      { headers: reqHeader });
  }
 

   // BRANCH MASTER------------------------------------------------------


   SaveBranch(strdata,logo): Observable<any> {
    let formData = new FormData();
    formData.append("branchDetails", strdata);
    formData.append("BranchLogoFile", logo);
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'SuperAdmin/SaveBranch', formData);
  }
  BranchMarkActive(strdata: any): Observable<any> {  
    let Parameter = 'objModel=' + strdata;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'SuperAdmin/BranchMarkActive?'
     + encodeURI(Parameter),
      { headers: reqHeader });
  }

  BindBranch(strdata: any): Observable<any> {  
    let Parameter = 'strdata=' + strdata;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'SuperAdmin/BindBranch?'
     + encodeURI(Parameter),
      { headers: reqHeader });
  }

  ResetSchoolBrachLoginID(strdata: any): Observable<any> {  
    let Parameter = 'objModel=' + strdata;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'SuperAdmin/ResetSchoolBrachLoginID?'
     + encodeURI(Parameter),
      { headers: reqHeader });
  }

   //SESSION MASTER------------------------------------------------------------------


   SaveSession(strdata: any): Observable<any> {
    let Parameter = 'objSession=' + strdata;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'SuperAdmin/SaveSession?' + encodeURI(Parameter),
      { headers: reqHeader });
  }

  SessionMarkActive(strdata: any): Observable<any> {  
    let Parameter = 'objSession=' + strdata;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'SuperAdmin/SessionMarkActive?'
     + encodeURI(Parameter),
      { headers: reqHeader });
  }

  GetSession(BranchID): Observable<any> {
    let Parameter = 'BranchID=' + BranchID;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
     return this.httpclient.post<any>(this.globalHelper.ApiUrl +
      'SuperAdmin/GetSession?'+ encodeURI(Parameter), { headers: reqHeader });
  }


  //Class Group------------------------------------------------------------------


  SaveClassGroup(strdata: any): Observable<any> {
    let Parameter = 'objClass=' + strdata;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'SuperAdmin/SaveClassGroup?' + encodeURI(Parameter),
      { headers: reqHeader });
  }

  ClassGroupMarkActive(strdata: any): Observable<any> {  
    let Parameter = 'objClass=' + strdata;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'SuperAdmin/SaveClassGroup?'
     + encodeURI(Parameter),
      { headers: reqHeader });
  }

  GetAllClassGroup(BranchID): Observable<any> {
    let Parameter = 'BranchID=' + BranchID;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
     return this.httpclient.post<any>(this.globalHelper.ApiUrl +
      'SuperAdmin/GetClassGroup?'+ encodeURI(Parameter), { headers: reqHeader });
  }


  //Class------------------------------------------------------------------

  SearchAllClass(BranchID): Observable<any> {
    let Parameter = 'BranchID='+ BranchID
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
     return this.httpclient.post<any>(this.globalHelper.ApiUrl +'SuperAdmin/GetClass?'+ encodeURI(Parameter),
       { headers: reqHeader });
  }

  SaveClass(strdata: any): Observable<any> {
    let Parameter = 'objClass=' + strdata;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'SuperAdmin/SaveClass?' + encodeURI(Parameter),
      { headers: reqHeader });
  }


  ClassMarkActive(strdata): Observable<any> {
    var param = 'objClass=' + strdata;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' }); return this.httpclient.post<any>(this.globalHelper.ApiUrl +
      'SuperAdmin/SaveClass?' + encodeURI(param), { headers: reqHeader });
  }


  //Section------------------------------------------------------------------

  SaveSection(strdata): Observable<any> {
    var param = 'objSection=' + strdata;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' }); return this.httpclient.post<any>(this.globalHelper.ApiUrl +
      'SuperAdmin/SaveSection?' + encodeURI(param), { headers: reqHeader });
  }

  SectionMarkActive(strdata): Observable<any> {
    var param = 'objSection=' + strdata;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' }); 
    return this.httpclient.post<any>(this.globalHelper.ApiUrl +
      'SuperAdmin/SectionMarkActive?' + encodeURI(param), { headers: reqHeader });
  }
  GetSection(BranchID): Observable<any> {
    var param = 'BranchID=' + BranchID;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
     return this.httpclient.post<any>(this.globalHelper.ApiUrl +
      'SuperAdmin/GetSection?' + encodeURI(param), { headers: reqHeader });
  }

  // Organization Details

  GetOrganizationDetails(): Observable<any> {
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' }); return this.httpclient.post<any>(this.globalHelper.ApiUrl +
      'SuperAdmin/GetOrganizationDetails', { headers: reqHeader });
  }

  SaveOrganizationDetails(strdata,logo): Observable<any> {
    let formData = new FormData();
    formData.append("objModel", strdata);
    formData.append("FileUpload", logo);
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'SuperAdmin/SaveOrganizationDetails', formData);
  }

  //PAGE SETUP-------------------------------------------------------------
  
 SavePageSetUp(strdata): Observable<any> {
    var param = 'objPageSetUp=' + strdata;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'SuperAdmin/SavePageSetUp?' + encodeURI(param), { headers: reqHeader });
  }
  GetAllPageSetUp(strdata): Observable<any> {
    var param = 'objPageSetUp=' + strdata;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'SuperAdmin/GetAllPageSetUp?' + encodeURI(param), { headers: reqHeader });
  }
  SiteMapMarkActive(strdata): Observable<any> {
    var param = 'objPageSetUp=' + strdata;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'SuperAdmin/SiteMapMarkActive?' + encodeURI(param),
      { headers: reqHeader });
  }

  // SMS API
  GetAllApi(): Observable<any> {
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'SMS/GetSMSApi',
      { headers: reqHeader });
  }

  SaveSMSApi(strdata,logo): Observable<any> {
    let formData = new FormData();
    formData.append("objApi", strdata);
    formData.append("FileUpload", logo);
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'SMS/SaveSMSApi', formData);
  }
  
  SMSApiMarkActive(strdata): Observable<any> {
    var param = 'objModel=' + strdata;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'SMS/SMSApiMarkActive?' + encodeURI(param),
      { headers: reqHeader });
  }

  // TRANSACTIONAL ACCOUNT

  GetAccount(strdata): Observable<any> {
    var param = 'objAccount=' + strdata;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'SMS/GetAccount?' + encodeURI(param),
      { headers: reqHeader });
  }

  TranAccMarkActive(strdata): Observable<any> {
    var param = 'objAccount=' + strdata;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'SMS/TranAccMarkActive?' + encodeURI(param),
      { headers: reqHeader });
  }

  SaveAccount(strdata): Observable<any> {
    var param = 'objAccount=' + strdata;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'SMS/SaveAccount?' + encodeURI(param),
      { headers: reqHeader });
  }


// ADS SLIDER//


SaveAdsSlider(data, HeaderLogoPath): Observable<any> {
  
  let formData = new FormData();
  formData.append("objSlider", data);
  formData.append("Slider", HeaderLogoPath);

  return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Administration/SaveAdsSlider', formData);
}



GetAdsSlider(): Observable<any> {
  
  var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
  return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Administration/GetAdsSlider',
        { headers: reqHeader });
}
AdsSliderMarkActive(strdata: any): Observable<any> {
  let Parameter = 'objSlider=' + strdata;
  var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
  return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Administration/AdsSliderMarkActive?'
    + encodeURI(Parameter),
    { headers: reqHeader });
}

}
